export default {
  ADD: 'NOTIFICATION_CENTER/ADD',
  RESET_TIMEOUT: 'NOTIFICATION_CENTER/RESET_TIMEOUT',
  HOVERED: 'NOTIFICATION_CENTER/HOVERED',
  REMOVE: 'NOTIFICATION_CENTER/REMOVE',
}
